<app-indicator-filter></app-indicator-filter>
<div *ngIf="indicatorStore.onlySets() as indicators">
  <p-listbox
    [options]="indicators"
    [(ngModel)]="selectedSet"
    optionLabel="name"
    (onChange)="selectSet()"
    [style]="{ width: 'w-full' }"
    [listStyle]="{ 'max-height': '30rem' }">
    <ng-template let-indicator pTemplate="item">
      <div class="w-full">
        <div class="flex align-items-center gap-2 text-lg pb-2">
          <i class="fas fa-ruler-combined"></i>
          <span>
            {{ indicator.name }}
          </span>
          <p-badge
            class="ml-auto"
            *ngIf="units[indicator.unit]"
            [value]="
              units[indicator.unit].symbol || units[indicator.unit].name
            "></p-badge>
        </div>
        <div class="flex align-items-center gap-2 pb-2">
          <p-tag
            [rounded]="true"
            *ngIf="indicator.parent"
            icon="fas fa-ruler-combined"
            styleClass="p-tag-parent"
            [value]="indicatorStore.getById(indicator.parent).name"></p-tag>
          <p-tag
            [rounded]="true"
            icon="fas fa-folder"
            styleClass="p-tag-category"
            [value]="categoryStore.getPathById(indicator.category)"></p-tag>
        </div>
        <app-tag-list
          styleClass="text-xs"
          *ngIf="indicator.tags?.length"
          [tagIds]="indicator.tags"></app-tag-list>
      </div>
    </ng-template>
  </p-listbox>
</div>
<p-divider></p-divider>
